import { render, staticRenderFns } from "./businessManagement.vue?vue&type=template&id=12f0eff2&scoped=true"
import script from "./businessManagement.vue?vue&type=script&lang=js"
export * from "./businessManagement.vue?vue&type=script&lang=js"
import style0 from "./businessManagement.vue?vue&type=style&index=0&id=12f0eff2&prod&scoped=true&lang=scss"
import style1 from "./businessManagement.vue?vue&type=style&index=1&id=12f0eff2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f0eff2",
  null
  
)

export default component.exports